export enum Strings {
    UID = 'uid',
    TABS = '/tabs',
    LOGIN = '/login',
    ADMIN = '/admin',
    TYPE = 'user'
}
